import datasetViewConfig from "../features/data-view/config/datasetViewConfig";
import {
  buildDetailModel,
  buildSummaryRowModel,
} from "../features/data-view/utils/recordMappers";

const stringifyValue = (value) => {
  if (value === null || value === undefined) {
    return "";
  }

  const normalized = String(value).trim();
  return normalized;
};

const pickFirstNonEmpty = (record, keys = []) => {
  for (const key of keys) {
    const value = stringifyValue(record?.[key]);
    if (value) {
      return value;
    }
  }
  return "";
};

export const deriveSemanticRecordId = (datasetKey, record, rank) => {
  const fallbackId = `${datasetKey}-${rank}`;

  if (!record || typeof record !== "object") {
    return fallbackId;
  }

  const datasetStrategies = {
    clinical_trials: ["nct_id", "nctId"],
    pubmed: ["PMID"],
    fda_510k: ["k_number"],
    fda_denovo: ["k_number"],
    fda_pma: ["pma_number", "supplement_number", "trade_name", "title"],
    fda_drugs: ["application_number", "drug_id"],
    google_patents: ["publication_number", "application_number"],
  };

  const strategy = datasetStrategies[datasetKey] || [];
  const derivedId = pickFirstNonEmpty(record, strategy);

  return derivedId || fallbackId;
};

export const normalizeSemanticResults = (datasetKey, rawResults = []) =>
  rawResults.map((rawRecord, index) => ({
    ...(rawRecord || {}),
    _record_id: deriveSemanticRecordId(datasetKey, rawRecord, index + 1),
    _semantic_rank: index + 1,
    _semantic_raw_record: rawRecord || {},
  }));

export const buildSemanticViewModels = (datasetKey, normalizedResults = []) => {
  const datasetConfig = datasetViewConfig[datasetKey];

  if (!datasetConfig) {
    return {
      rowModels: [],
      detailModelsById: {},
    };
  }

  const rowModels = normalizedResults.map((record) =>
    buildSummaryRowModel(record, datasetConfig)
  );
  const detailModelsById = normalizedResults.reduce((accumulator, record) => {
    accumulator[record._record_id] = buildDetailModel(record, datasetConfig);
    return accumulator;
  }, {});

  return {
    rowModels,
    detailModelsById,
  };
};

export const getDownloadableResultFromNormalized = (record) =>
  record?._semantic_raw_record || {};
